import React from 'react'
import { Row, Col } from 'antd';
import { Link } from 'react-router-dom';


function ExploreWide({ data }) {
    return (
        <div>
            <section className='ExploreWide'  >
                <div className="container">
                    <h2 className='theme-h2'>{data?.title}</h2>
                    <Row gutter={[50, 20]}>
                        {data?.categories.map((item,ind)=> (
                            <Col xs={24} sm={24} md={ind === 2 ? 24 : 12} lg={ind === 2 ? 24 : 12} xl={ind === 2 ? 24 : 12} key={ind}>
                                <Link to={item.link}>
                                    <div className="texture-explore-1" style={{ backgroundImage: `url(${item.image})` }}>
                                        <h2>{item.title}</h2>
                                    </div>
                                </Link>
                            </Col>
                        ))}

                    </Row>
                </div>
            </section>
        </div>
    )
}

export default ExploreWide
